import { render, staticRenderFns } from "./ContractedWorksTask.vue?vue&type=template&id=2c6c8808&"
import script from "./ContractedWorksTask.vue?vue&type=script&lang=js&"
export * from "./ContractedWorksTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports